import { maxLength } from '@carboledger/ui';
import { getTranslation } from '@/lib/utils/i18n';
import { TERMINAL_NAME_MAX_LENGTH } from './constants/sites.constants';

export const siteValidation = {
  terminalName: [
    maxLength(
      TERMINAL_NAME_MAX_LENGTH,
      getTranslation('VALIDATION_MAX_LENGTH', { max: TERMINAL_NAME_MAX_LENGTH }),
    ),
  ],
};
